// Small branded pieces shared by the portal's auth pages and report view.

import { Box, Link, Typography } from '@mui/material'

import { usePortal } from './portalContext'

export function PortalBrand({ inverse = false }: { inverse?: boolean }) {
    const { portal } = usePortal()
    const { logoUrl, productName } = portal.branding
    return logoUrl ? (
        <Box
            component="img"
            src={logoUrl}
            alt={productName}
            sx={{ maxHeight: 36, maxWidth: 200, objectFit: 'contain', display: 'block' }}
        />
    ) : (
        <Typography
            variant="h6"
            noWrap
            sx={{ fontWeight: 700, color: inverse ? 'primary.contrastText' : 'primary.main' }}
        >
            {productName}
        </Typography>
    )
}

/** "Powered by YOM" — only when the portal's plan/branding requires it. */
export function PoweredBy({ show }: { show: boolean }) {
    if (!show) {
        return null
    }
    return (
        <Typography variant="caption" color="text.secondary" component="div" sx={{ py: 2 }}>
            Powered by{' '}
            <Link
                href="https://yom.aapastech.com"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                color="inherit"
            >
                YOM
            </Link>
        </Typography>
    )
}
